import React from "react";

import { CheckBoxList } from "../../components/CheckBoxList";
import { Numeric } from "../../components/Numeric";
import YesNo from "../../components/YesNo";
import DatePicker from "../../components/DatePicker";

import "../../styles/widgets.scss";

export default class Widget extends React.Component {
  render() {
    const {
      updateWidget,
      WidgetId,
      DisplayLabel,
      WidgetType,
      DataType,
      Values,
      Value,
      AvailableOptions,
      ValidationMessages,
    } = this.props;
    const HasErrors = ValidationMessages && ValidationMessages.length > 0;
    let opt =
      (AvailableOptions &&
        AvailableOptions.filter((o) => o.IsVisible === true).map((o) => {
          return { name: o.DisplayLabel, value: o.Value };
        })) ||
      [];

    return (
      <div className="widget form-group">
        <div className="widget-label">{DisplayLabel}</div>
        {WidgetType === "CheckBoxList" && (
          <CheckBoxList
            options={opt}
            values={Values}
            onChange={(value) => updateWidget(WidgetId, value)}
          />
        )}
        {WidgetType === "DropDown" && (
          <select
            name={WidgetId}
            className="coverage-value-dropdown"
            onChange={(e) => {
              updateWidget(WidgetId, [e.target.value]);
            }}
            id={WidgetId}
            value={Value}
          >
            {AvailableOptions.map((item) => (
              <option key={item.Value} value={item.Value}>
                {item.DisplayLabel}
              </option>
            ))}
          </select>
        )}
        {WidgetType === "TextBox" && DataType === "Int" && (
          <Numeric
            value={Value}
            onValueChanged={(value) => updateWidget(WidgetId, [value.value])}
          />
        )}
        {WidgetType === "TextBox" && DataType !== "Int" && (
          <input
            className="text-box"
            type="text"
            defaultValue={Value}
            onBlur={(e) => updateWidget(WidgetId, [e.target.value])}
          />
        )}
        {WidgetType === "ToggleButton" && (
          <YesNo
            AvailableOptions={AvailableOptions}
            Values={Values}
            onValueChanged={(value) => updateWidget(WidgetId, [value])}
          />
        )}
        {WidgetType === "DatePicker" && (
          <DatePicker
            {...this.props}
            onValueChanged={(value) => updateWidget(WidgetId, [value])}
          />
        )}
        <div className="error-message" hidden={!HasErrors}>
          {ValidationMessages[0]}
        </div>
      </div>
    );
  }
}
